/**
 * Default Tenant Logo Component
 *
 * "Quad" mark — four rounded squares in a 2×2 grid: a neutral, universally
 * legible workspace / organisation placeholder. Shown in the workspace header
 * upper-left corner for a tenant that has configured no `branding.logo_icon_url`
 * of its own. It keeps the white monoline treatment and the four-fold
 * rotational symmetry of KobottoLogo, but shares no shape with it — so an
 * unbranded tenant is never visually mistaken for the Kobotto SaaS brand
 * (spec: tenant-dual-logo).
 */

import React from 'react';

interface DefaultTenantLogoProps {
  size?: number;
  className?: string;
}

const MARK_COLOR = 'rgba(255, 255, 255, 0.95)';

const DefaultTenantLogo: React.FC<DefaultTenantLogoProps> = ({
  size = 48,
  className = '',
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Tenant logo"
        role="img"
      >
        {/* Four units — a 2×2 grid with four-fold rotational symmetry */}
        <rect x="16" y="16" width="30" height="30" rx="5" fill={MARK_COLOR} />
        <rect x="54" y="16" width="30" height="30" rx="5" fill={MARK_COLOR} />
        <rect x="16" y="54" width="30" height="30" rx="5" fill={MARK_COLOR} />
        <rect x="54" y="54" width="30" height="30" rx="5" fill={MARK_COLOR} />
      </svg>
    </div>
  );
};

export default DefaultTenantLogo;
